import {client} from '@dokia/contract/webapp/client.gen';

import {
  AuthSessionExpiredError,
  refreshAuthSessionAccessToken,
} from './authSession';

export class ServerError extends Error {
  name = 'ServerError';

  constructor(
    public readonly status: number,
    public readonly body: unknown,
  ) {
    super(`Server error ${String(status)}`);
  }
}

export class SessionExpiredError extends Error {
  name = 'SessionExpiredError';

  constructor() {
    super('Session expired');
  }
}

const apiBase =
  (import.meta.env.VITE_API_URL as string | undefined) ?? '';
client.setConfig({
  baseUrl: `${apiBase}/webapp`,
  credentials: 'include',
});

let _accessToken: string | undefined;

export function setServerClientAccessToken(token: string | undefined): void {
  _accessToken = token;
}

client.interceptors.request.use(request => {
  if (_accessToken) {
    request.headers.set('Authorization', `Bearer ${_accessToken}`);
  } else {
    request.headers.delete('Authorization');
  }
  return request;
});

client.interceptors.response.use(async (response, request, options) => {
  if (response.status !== 401 || !request.headers.has('Authorization')) {
    return response;
  }

  try {
    const refreshedAccessToken = await refreshAuthSessionAccessToken({
      baseUrl: client.getConfig().baseUrl ?? '',
    });
    setServerClientAccessToken(refreshedAccessToken);

    const retryHeaders = new Headers(request.headers);
    retryHeaders.set('Authorization', `Bearer ${refreshedAccessToken}`);

    return await globalThis.fetch(request.url, {
      body: options.serializedBody,
      headers: retryHeaders,
      method: request.method,
    });
  } catch (error) {
    if (error instanceof AuthSessionExpiredError) {
      throw new SessionExpiredError();
    }

    throw error;
  }
});
